
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/order-items",
      function () {
        return require("private-next-pages/order-items/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/order-items"])
      });
    }
  